import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  const t = theme.typography as unknown as Record<string, unknown>;
  return {
    large: (t.sectionHeading || {}) as Record<string, unknown>,
    medium: (t.sectionHeadingMedium || {}) as Record<string, unknown>,
    small: (t.sectionHeadingSmall || {}) as Record<string, unknown>,
  };
});

interface SectionHeadingProps {
  id?: string;
  className?: string;
  children: React.ReactNode;
  component?: React.ElementType;
  size?: 'large' | 'medium' | 'small';
}

export default function SectionHeading({ id, className = '', children, component: Component = 'h2', size = 'medium' }: SectionHeadingProps) {
  const classes = useStyles();
  return (
    <Component id={id} className={`${classes[size]} ${className}`.trim()}>
      {children}
    </Component>
  );
}
